import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Rating from 'components/UI/Rating/Rating';
import Heading from 'components/UI/Heading/Heading';
import Text from 'components/UI/Text/Text';
import Button from 'components/UI/Antd/Button/Button';
import Paragraph from 'components/UI/Antd/Paragraph/Paragraph';
import useWindowSize from 'library/hooks/useWindowSize';
import DescriptionWrapper from './Description.style';
import { RatingMeta, TextButton } from '../SinglePageView.style';
import Association from 'components/Association/Association';

const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop);
const rows = 5;
const contentLength = 1000;
const lineHeight = 24;

const Description = ({
  city,
  country,
  content,
  associationType,
  title,
  rating,
  ratingCount,
  titleStyle,
  locationMetaStyle
}) => {
  const { width } = useWindowSize();
  const { t, i18n } = useTranslation();
  const [expand, setExpand] = useState(true);
  const [expandButtonVisible, setExpandButtonVisible] = useState(false);
  const descriptionWrapperRef = useRef(null);
  const executeScroll = () => scrollToRef(descriptionWrapperRef);
  const toggleExpand = () => {
    setExpand(!expand);
    if (!expand) {
      executeScroll();
    }
  };

  useEffect(() => {
    const descriptionHeight =
      document.getElementById('marinaDescription').offsetHeight;
    if (descriptionHeight > rows * lineHeight) {
      setExpandButtonVisible(true);
    } else setExpandButtonVisible(false);
  }, [width, i18n.language]);

  const getFormattedContent = () => {
    return content[i18n.language] ? content[i18n.language] : content['en']
      // ? content[i18n.language]
      //     .split('\n\n')
      //     .map(paragraph => (
      //       <p>
      //         {paragraph
      //           .split('\n')
      //           .reduce((total, line) => [total, <br />, line])}
      //       </p>
      //     ))
      // : '';
  };

  return (
    <Element name='overview' className='overview'>
      <DescriptionWrapper ref={descriptionWrapperRef}>
        {width > 767 && (
          <Fragment>
            <Text
              content={`${city}, ${t(country)}`}
              {...locationMetaStyle}
              className='marinaLocation'
            />
            <Heading
              as='h1'
              content={title}
              {...titleStyle}
              className='marinaName'
            />
          </Fragment>
        )}
        <Association
          associationType={associationType}
          view='marinaSinglePage'
          marinaName={title}
        />
        {rating && rating !== 'undefined' && ratingCount >= 20 && (
          <RatingMeta>
            <Rating rating={rating} ratingCount={ratingCount} type='bulk' />
          </RatingMeta>
        )}
        <Paragraph
          id='marinaDescription'
          style={{ lineHeight: `${lineHeight}px`, whiteSpace: 'pre-wrap' }}
          ellipsis={{
            rows: expand ? 5 : null,
            expandable: expand
          }}
        >
          {getFormattedContent()}
        </Paragraph>

        {expandButtonVisible && (
          <TextButton>
            <Button onClick={toggleExpand}>
              {expand ? t('READ_MORE_ABOUT_MARINA') : t('SHOW_LESS')}
            </Button>
          </TextButton>
        )}
      </DescriptionWrapper>
    </Element>
  );
};

Description.propTypes = {
  titleStyle: PropTypes.object,
  locationMetaStyle: PropTypes.object
};

Description.defaultProps = {
  titleStyle: {
    color: '#2C2C2C',
    fontSize: ['17px', '20px', '25px'],
    lineHeight: ['1.15', '1.2', '1.36'],
    mb: '4px'
  },
  locationMetaStyle: {
    fontSize: '13px',
    fontWeight: '400',
    color: '#909090'
  }
};

export default Description;
